<template>
  <RevButtonBase
    :aria-label="COMPANY_NAME"
    :to="to"
    :tracking="{ name: 'logo', zone: 'header' }"
  >
    <RevIllustration
      :alt="COMPANY_NAME"
      :height="24"
      src="/img/header/Logo.svg"
      :width="180"
    />
  </RevButtonBase>
</template>

<script setup lang="ts">
import { useRouteLocationWithLocale, useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevIllustration } from '@ds/components/Illustration'

import { HOME } from '~/scopes/home/route-names'

const props = withDefaults(defineProps<{ disabled?: boolean }>(), {
  disabled: false,
})

const runtimeConfig = useRuntimeConfig()
const resolveLocalizedRoute = useRouteLocationWithLocale()
const { COMPANY_NAME } = runtimeConfig.public

const to = computed(() => {
  return props.disabled ? '' : resolveLocalizedRoute({ name: HOME })
})
</script>
